import React from 'react';
import { twMerge } from 'tailwind-merge';
import classNames from 'classnames';

export enum CardCategory {
  MANDATORY = 'mandatory',
  OFFER = 'offer',
  FIRST_AID = 'first_aid',
  MATERNITY = 'maternity',
  INSTRUCTION = 'instruction',
}

const CONTAINER_BG: Record<CardCategory, string> = {
  [CardCategory.MANDATORY]: 'bg-ds-bg-category-soft-1',
  [CardCategory.OFFER]: 'bg-ds-bg-category-soft-2',
  [CardCategory.FIRST_AID]: 'bg-ds-bg-feedback-soft-info',
  [CardCategory.MATERNITY]: 'bg-ds-bg-feedback-soft-info',
  [CardCategory.INSTRUCTION]: 'bg-ds-border-gradient-4',
};

const BANNER_BG: Record<CardCategory, string> = {
  [CardCategory.MANDATORY]: 'bg-ds-bg-category-1',
  [CardCategory.OFFER]: 'bg-ds-bg-category-2',
  [CardCategory.FIRST_AID]: 'bg-ds-border-gradient-4',
  [CardCategory.MATERNITY]: 'bg-ds-border-gradient-4',
  [CardCategory.INSTRUCTION]: 'bg-ds-bg-feedback-soft-info',
};

export interface CardCategoryLabelProps {
  className?: string;
  children?: React.ReactNode;
  category: CardCategory;
}

export const CardCategoryLabel: React.FC<CardCategoryLabelProps> = ({
  className,
  children,
  category,
}) => {
  const containerClasses = twMerge(
    classNames(
      'rounded-t-md rounded-b-2xl text-ds-text-s font-ds-semibold',
      CONTAINER_BG[category],
      className,
    ),
  );

  const bannerClasses = classNames('h-1.25 rounded-t-md', BANNER_BG[category]);

  return (
    <div className={containerClasses}>
      <div className={bannerClasses} />
      <div className="pt-1.5 pb-3 px-3.5">{children}</div>
    </div>
  );
};
